<template>
  <div>
    <template v-if="options" class="uk-select">{{ findValue() }}</template>
    <template v-else>
      <vk-spinner></vk-spinner>
    </template>
  </div>
</template>

<script>
export default {
  name: "selectbox",
  data() {
    return {
      model: null,
      options: null
    };
  },
  props: ["input", "form", "rowdata"],
  created() {
    this.model = this.rowdata;
  },
  methods: {
    findValue() {
      if (this.model) {
        let returnz = this.options.find(val => val.value === this.model);
        if (returnz) {
          return returnz.label;
        }
      }
    }
  },
  mounted() {
    if (this.input.id > 0) {
      this.options = this.$root.cache.getOptions[this.input.id];
    }
  },
  watch: {
    form() {
      if (this.form) {
        this.model = null;
      }
    },
    model() {
      this.$parent.$emit("change", {
        name: this.input.name,
        value: this.model
      });
    }
  }
};
</script>

<style></style>
